import React from 'react'
import { createRoot } from 'react-dom/client';
import App from './App'

const container = document.getElementById('pricing-app');
const root = createRoot(container);

import { initI18N } from '../../i18next';

let product = container.dataset.product;
if (product){
    product = product.toLowerCase();
}

initI18N().then(() => {
    root.render(<App product={product} />);
});